<template>
    <Breadcrumb
        v-if="breadcrumbs"
        class="mx-6 text-xl"
    >
        <BreadcrumbItem
            v-for="breadcrumb of breadcrumbs"
            :key="breadcrumb.route"
        >
            <RouterLink
                v-if="breadcrumb.name !== $route.name"
                :to="{ name: breadcrumb.name }"
            >
                <Icon
                    v-if="breadcrumb.icon"
                    class="mr-1 icon"
                    :type="breadcrumb.icon"
                />
                {{ $t(breadcrumb.title) }}
            </RouterLink>
            <span v-else>
                <Icon
                    v-if="breadcrumb.icon"
                    class="mr-1 icon"
                    :type="breadcrumb.icon"
                />
                {{ $t(breadcrumb.title) }}
            </span>
        </BreadcrumbItem>
    </Breadcrumb>
</template>

<script>
import { Breadcrumb, Icon } from 'ant-design-vue';

export default {
    components: {
        Breadcrumb,
        BreadcrumbItem: Breadcrumb.Item,
        Icon,
    },
    computed: {
        breadcrumbs() {
            return this.$route.meta.breadcrumbs;
        },
    },
};
</script>

<style scoped>
.icon {
    font-size: 18px !important;
    position: relative;
    top: -2px;
}
</style>
